import PrintBulkCashComponent from './print_bulk_cash.component';

let PrintBulkCashModule = angular.module('printBulkCash', [])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$stateProvider
			.state('printBulkCash', {
				url: '/bulk-cash-print',
				component: 'printBulkCash',
				data: {
					requireLogin: true,
					requireACL: 'bulk_cash_management.all,view'
				},
			});
	})
	.component('printBulkCash', PrintBulkCashComponent)
	.name;

export default PrintBulkCashModule;



// WEBPACK FOOTER //
// ./client/app/components/bulk_cash_management/print/index.js